import React, { useState, useEffect } from "react";
import usefetchdata from "hooks/usefetchdata";
import axios from "axios";
import { toast } from "react-toastify";
import LoadingButton from "components/button/loading.js";
import Modalheader from "components/modal/components/header.js";
import ModalBody from "components/modal/components/body.js";
import ModalFooter from "components/modal/components/footer.js";
import UseContext from "hooks/useContext";
import useModal from "components/modal/useModal.js";
import Button from "components/button/index.js";
import Pi from "components/modal/dataModal/data/modaljustify/identity/components/body/import/pi.js";
import Selfie from "components/modal/dataModal/data/modaljustify/identity/components/body/selfie";
import Autorisationtravail from "components/modal/dataModal/data/modaljustify/identity/components/body/autorisationtravail";
import IndicatorIdentity from "./components/body/import/indicator.js";
import Footerbutton from "components/modal/dataModal/data/modaljustify/identity/components/body/import/footerbutton.js";
import Confirmationimport from "./components/body/import/confirmationimport.js";
import CheckFilesIdentity from "./components/body/checkFilesIdentity";
import { convertPdfToImageIfNeeded } from "utils/pdfToImage";
const Modalidentityimport = () => {
    const { tempWorkerData } = usefetchdata();
    const { refreshLoadWorker, language, isWebcamToUse, setIsWebcamToUse } = UseContext();
    const [formIndex, setFormIndex] = useState(1);
    const [nationality, setNationality] = useState("");
    const [check, setCheck] = useState(false);
    const [loading, setLoading] = useState(false);
    const [detectCaptureWebcam, setDetectCaptureWebcam] = useState(false);
    const { toggle } = useModal();

    const [pi, setPi] = useState({
        type: "",
        fileR: null,
        fileV: null,
        nationality: "",
    });
    const [selfie, setSelfie] = useState(null);
    const [visa, setVisa] = useState({
        type: "",
        fileR: null,
        fileV: null,
        nationality: "",
    });

    const prev = () => {
        setFormIndex(formIndex - 1);
    };
    useEffect(() => {
        if (pi.nationality !== "" && pi.nationality !== nationality) {
            setNationality(pi.nationality);
        }
    }, [pi.nationality]);

    // Log current page
    useEffect(() => {
        console.log(`📄 [Modal Identity Import] Page actuelle: ${formIndex}`);
    }, [formIndex]);
    const elements = [
        <Pi
            key={Pi}
            pi={pi}
            setPi={setPi}
            check={check}
            setCheck={setCheck}
            formIndex={formIndex}
        />,
        <CheckFilesIdentity key={CheckFilesIdentity} files={[pi.fileR, pi.fileV]} />,
        <Selfie key={Selfie} setSelfie={setSelfie} setDetectCaptureWebcam={setDetectCaptureWebcam} />,
        <CheckFilesIdentity key={CheckFilesIdentity} files={[selfie]} />,
        <Confirmationimport
            key={Confirmationimport}
            userData={tempWorkerData}
            setFormIndex={setFormIndex}
            nationality={nationality}
        />,
    ];
    const elements2 = [
        <Pi
            key={Pi}
            pi={pi}
            setPi={setPi}
            check={check}
            setCheck={setCheck}
            formIndex={formIndex}
        />,
        <CheckFilesIdentity key={CheckFilesIdentity} files={[pi.fileR, pi.fileV]} />,
        <Selfie key={Selfie} setSelfie={setSelfie} setDetectCaptureWebcam={setDetectCaptureWebcam} />,
        <CheckFilesIdentity key={CheckFilesIdentity} files={[selfie]} />,
        <Autorisationtravail
            key={Autorisationtravail}
            setVisa={setVisa}
            visa={visa}
        />,
        <CheckFilesIdentity key={CheckFilesIdentity} files={[visa.fileR, visa.fileV]} />,
        <Confirmationimport
            key={Confirmationimport}
            userData={tempWorkerData}
            setFormIndex={setFormIndex}
            nationality={nationality}
        />,
    ];

    const state1 = (f) =>
        f.type !== "" && f.nationality !== "" && f.fileR !== "";
    const state2 = (f) => f !== null && f !== "";
    const state3 = (f) =>
        f.type !== "" &&
        f.fileR !== "" &&
        ((f.type === "Visa" && f.fileV !== "") || f.type === "RTS");
    
    const handleIndex = (e) => {
        if (!check) {
            toast.warning("Veuillez cocher l'attestation sur l'honneur");
            return;
        }

        if (formIndex < 1) {
            setFormIndex(1);
            return;
        }

        // Navigation séquentielle page par page
        // Pour UE : Pages 1 → 2 → 3 → 4 → Confirmer
        // Pour NUE : Pages 1 → 2 → 3 → 4 → 5 → 6 → Confirmer
        
        const isNUE = pi.nationality === "NUE" || nationality === "NUE";
        
        // Page 1 : Upload identité → Page 2 (affichage identité)
        if (formIndex === 1) {
            if (state1(pi)) {
                // Vérifier si CNI nécessite aussi le verso
                if (pi.type === "CNI" && !pi.fileV) {
                    toast.warning("Veuillez importer le verso de la CNI");
                    return;
                }
                setFormIndex(2);
            } else {
                toast.warning("Veuillez remplir tous les champs de l'identité");
            }
        }
        // Page 2 : Affichage identité → Page 3 (upload selfie)
        else if (formIndex === 2) {
            setFormIndex(3);
        }
        // Page 3 : Upload selfie → Page 4 (affichage selfie)
        else if (formIndex === 3) {
            if (state2(selfie)) {
                setFormIndex(4);
            } else {
                toast.warning("Veuillez importer le selfie");
            }
        }
        // Page 4 : Affichage selfie → Page 5 (upload visa) pour NUE uniquement
        // Pour UE, le bouton "Confirmer" (oC2) appellera handleSubmitMulti directement
        else if (formIndex === 4) {
            if (isNUE) {
                setFormIndex(5);
            }
            // Pour UE, on ne fait rien ici car le bouton "Confirmer" gérera l'envoi via handleSubmitMulti
        }
        // Page 5 : Upload visa/RTS → Page 6 (affichage visa) pour NUE
        else if (formIndex === 5) {
            if (state3(visa)) {
                setFormIndex(6);
            } else {
                toast.warning("Veuillez remplir tous les champs du visa/RTS");
            }
        }
        // Page 6 : Affichage visa → Confirmer pour NUE
        else if (formIndex === 6) {
            // Le bouton "Confirmer" gérera l'envoi
        }
    };
    const f = async (formData, successMsg) => {
        setLoading(true);
        const idToastLoad = toast.loading("Envoi des fichiers en cours");
        try {
            const result = await axios.post(
                `${process.env.REACT_APP_API_URL}upload/files`,
                formData
            );
            if (result.status === 201) {
                setLoading(false);
                toast.update(idToastLoad, {
                    render: "Fichiers uploadés",
                    type: "success",
                    autoClose: 3000,
                    isLoading: false,
                });
                refreshLoadWorker();
                toggle();
            } else {
                setLoading(false);
                toast.update(idToastLoad, {
                    render: "Erreur d'envoi des fichiers",
                    type: "error",
                    isLoading: false,
                });
            }
        } catch (error) {
            setLoading(false);
            toast.update(idToastLoad, {
                render: "Erreur d'envoi des fichiers",
                type: "error",
                isLoading: false,
            });
        }
    };

    //UE - PASSEPORT -SELFIE
    const uePassSelfie = async (formData) => {
        await f(formData, 'Le document "Identité" est' + " ajouté.");
    };

    //UE - CNI RECTO - CNI VERSO -SELFIE
    const ueCniSelfie = async (formData) => {
        await f(formData, 'Le document "Identité" est' + " ajouté.");
    };

    //NUE PASSEPORT - SELFIE - RTS
    const etrPasseportSelfieRts = async (formData) => {
        await f(formData, 'Le document "Identité" est' + " ajouté.");
    };
    //NUE PASSEPORT - SELFIE - VISA R - VISA V
    const etrPasseportSelfieVisaRV = async (formData) => {
        await f(formData, 'Le document "Identité" est' + " ajouté.");
    };
    //NUE CNI R - CNI V - SELFIE - RTS
    const etrCniSelfieVisaR = async (formData) => {
        await f(formData, 'Le document "Identité" est' + " ajouté.");
    };
    //NUE CNI R - CNI V - SELFIE - VISA R - VISA V
    const etrCniSelfieVisaRV = async (formData) => {
        await f(formData, 'Le document "Identité" est' + " ajouté.");
    };

    const handleSubmitMulti = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem("xsrfToken");
        const formData = new FormData();
        formData.append("token", token);

        // Vérifier que tous les champs requis sont remplis avant l'envoi
        const isNUE = pi.nationality === "NUE" || nationality === "NUE";
        
        if (!check) {
            toast.warning("Veuillez cocher l'attestation sur l'honneur");
            return;
        }
        
        if (!state1(pi)) {
            toast.warning("Veuillez remplir tous les champs de l'identité");
            return;
        }
        
        if (pi.type === "CNI" && !pi.fileV) {
            toast.warning("Veuillez importer le verso de la CNI");
            return;
        }
        
        if (!state2(selfie)) {
            toast.warning("Veuillez importer le selfie");
            return;
        }
        
        if (isNUE && !state3(visa)) {
            toast.warning("Veuillez remplir tous les champs du visa/RTS");
            return;
        }

        if (check && pi.fileR !== "" && selfie !== null) {
            // Convert PDFs to images if needed
            const identityRFile = await convertPdfToImageIfNeeded(pi.fileR);
            const selfieFile = await convertPdfToImageIfNeeded(selfie);
            
            formData.append("identityR", identityRFile);
            formData.append("identityType", pi.type);
            formData.append("selfie", selfieFile);

            if (pi.type === "Passeport" && pi.nationality === "UE") {
                await uePassSelfie(formData);
            } else if (pi.type === "CNI" && pi.nationality === "UE") {
                const identityVFile = await convertPdfToImageIfNeeded(pi.fileV);
                formData.append("identityV", identityVFile);
                await ueCniSelfie(formData);
            } else if (pi.type === "Passeport" && pi.nationality === "NUE") {
                const visaRFile = await convertPdfToImageIfNeeded(visa.fileR);
                formData.append("visaR", visaRFile);
                formData.append("visaType", visa.type);
                if (visa.type === "RTS") {
                    await etrPasseportSelfieRts(formData);
                } else {
                    const visaVFile = await convertPdfToImageIfNeeded(visa.fileV);
                    formData.append("visaV", visaVFile);
                    await etrPasseportSelfieVisaRV(formData);
                }
            } else if (pi.type === "CNI" && pi.nationality === "NUE") {
                const identityVFile = await convertPdfToImageIfNeeded(pi.fileV);
                const visaRFile = await convertPdfToImageIfNeeded(visa.fileR);
                formData.append("identityV", identityVFile);
                formData.append("visaR", visaRFile);
                formData.append("visaType", visa.type);
                if (visa.type === "RTS") {
                    await etrCniSelfieVisaR(formData);
                } else {
                    const visaVFile = await convertPdfToImageIfNeeded(visa.fileV);
                    formData.append("visaV", visaVFile);
                    await etrCniSelfieVisaRV(formData);
                }
            }
        } else {
            toast.warning("Veuillez remplir tous les champs (identité et selfie)");
        }
    };

    useEffect(() => {
        if(detectCaptureWebcam){
            handleIndex()
            setDetectCaptureWebcam(false)
        }
    }, [detectCaptureWebcam]);

    return (
        <>
            <Modalheader hide={toggle} hideShow={true}>
                {language.getValue("justify.m_identity_title_c")}
            </Modalheader>
            <ModalBody>
                <IndicatorIdentity
                    pi={pi}
                    nationality={nationality}
                    formIndex={formIndex}
                />
                {(pi.nationality === "NUE" || nationality === "NUE"
                    ? elements2
                    : elements
                ).filter((item, index) => index + 1 === formIndex)}
            </ModalBody>
            <ModalFooter>
                {loading ? (
                    <LoadingButton size={"LG"} />
                ) : (
                    <>
                        {formIndex === 1 ? (
                            <Button
                                size={"LG"}
                                color={"SECONDARY"}
                                onClick={toggle}
                            >
                                Annuler
                            </Button>
                        ) : (
                            <>
                                {formIndex === 3 && (
                                    <div
                                        className="text-yellow-500 underline cursor-pointer mr-auto"
                                        onClick={() => {
                                            setIsWebcamToUse(!isWebcamToUse);
                                        }}
                                    >
                                        {isWebcamToUse ? 'Importer un fichier' : 'Prendre une photo'}
                                    </div>
                                )}
                                <Button
                                    size={"LG"}
                                    color={"SECONDARY"}
                                    onClick={prev}
                                >
                                    Précédent
                                </Button>
                            </>
                        )}
                        <Footerbutton
                            formIndex={formIndex}
                            pi={pi.nationality}
                            nationality={nationality}
                            oC1={handleIndex}
                            oC2={handleSubmitMulti}
                        />
                    </>
                )}
            </ModalFooter>
        </>
    );
};

export default Modalidentityimport;
